import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { DELIVERY_ADDRESS_PREFIX } from '../address/postalAddress.js';
import { addressFieldDescriptors } from './_addressFields.js';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { SHIPMENT, ShipmentStatusValues, SHIPMENT_STATUS_LABELS, } from '../types/shipment.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Shipment header (request 0110).
 * Path: org/{orgId}/shipment — PostgresRest (cross-query with SalesOrder / ledger).
 */
export const shipmentDescriptor = {
    name: SHIPMENT,
    label: 'Expedição',
    domain: 'sales',
    collectionPath: 'org/{orgId}/shipment',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Shipment header — outbound stock document for a sales order',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'shipmentNumber',
            example: '3301',
            label: 'Número da expedição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
        },
        { name: 'salesOrderId', label: 'Pedido', type: 'string', required: true },
        { name: 'customerId', label: 'Cliente', type: 'string', required: true },
        { name: 'stockLocationId', label: 'Local de estoque', type: 'string', required: true },
        { name: 'shipmentDate', example: '2026-10-28', label: 'Data da expedição', type: 'date', required: true },
        {
            name: 'status',
            example: 'posted',
            label: 'Status',
            type: 'enum',
            required: true,
            enumValues: [...ShipmentStatusValues],
            enumLabels: SHIPMENT_STATUS_LABELS,
            defaultValue: 'draft',
        },
        // Delivery address — the standard block under a **second prefix** (spec 0047
        // §4.3 / D36). Nine columns, `delivery_address_zip_code` … : PostgresRest, so
        // they only exist after `system-api build` + restart (`pgSchema` verifies the
        // table once per process).
        //
        // No unprefixed `address` block: a shipment has one address, the delivery
        // one. Spreading both would leave nine dead columns that `pgSchema` never
        // drops. The label prefix is what keeps a column picker from offering a bare
        // `CEP` whose meaning the operator has to guess.
        ...addressFieldDescriptors(DELIVERY_ADDRESS_PREFIX, 'Entrega'),
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    // No address FK (D31): `deliveryAddressCityId`/`deliveryAddressStateId` hold
    // IBGE codes, not references.
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'salesOrderId',
            targetEntity: 'SalesOrder',
            relationship: 'many-to-one',
            displayField: 'code',
        },
        {
            fieldName: 'customerId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=shipment.descriptor.js.map